import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-invite-primary-host',
  templateUrl: './dialog-invite-primary-host.component.html',
  styleUrls: ['./dialog-invite-primary-host.component.scss'],
})
export class DialogInvitePrimaryHostComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private readonly router: Router,
    public dialogRef: MatDialogRef<DialogInvitePrimaryHostComponent>
  ) { }

  listings: any;

  platform: string = null;
  platformId: string = null;

  ngOnInit(): void {
    this.listings = this.dialogData.account.co_host_only_listings;

    // Let's have it for Airbnb only for now. Other platforms are not supported anyway but let's play safe
    if (this.dialogData.account.platform === 'Airbnb' && this.dialogData.account.platform_id) {
      this.platform = 'airbnb-official';
      this.platformId = this.dialogData.account.platform_id;
    }
  }

  invite() {
    this.router.navigate(['/accounts/new/invite'], {
      queryParams: {
        platform: this.platform,
        platform_id: this.platformId
      }
    });
    this.dialogRef.close();
  }
}
